import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setHelperText,
  WeekoffPlanner,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../Assets/Images/aaa.png";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
});

class Accumulation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isaccumulation: "",
      expanded05: true,
      expanded06: "",
      refreshtypeid: "",
      expanded09: true,
      expanded10: "",
      helperText: "",
      accumulationtypeid: "",
      accumulationlimit: "",
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    this.props.ChangeLanguage("weekoff,navigation");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.OnNext,
    });
    if (this.props.Language.weekoff) {
      const text = this.props.Language.weekoff.HtAllowacc;
      this.props.setHelperText({ helperText: text });
    }
    const weekoffPlannerInfo = this.props.weekoffPlannerReducer;
    if (this.isEmpty(weekoffPlannerInfo)) {
      const { weekoffdays } = weekoffPlannerInfo;
      const isaccumulation = weekoffPlannerInfo.isaccumulation
        ? weekoffPlannerInfo.isaccumulation
        : false;
      const accumulationtypeid = weekoffPlannerInfo.accumulationtypeid
        ? weekoffPlannerInfo.accumulationtypeid
        : 1;
      const refreshtypeid = weekoffPlannerInfo.refreshtypeid
        ? weekoffPlannerInfo.refreshtypeid
        : 1;
      const accumulationlimit = weekoffPlannerInfo.accumulationlimit
        ? weekoffPlannerInfo.accumulationlimit
        : null;
      this.setState({
        isaccumulation,
        accumulationtypeid,
        refreshtypeid,
        accumulationlimit,
        weekoffdays,
      });
    } else {

    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  isEmpty(obj) {
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] == "undefined") return false;
    });
    return true;
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.weekoff[${HtField}]`, "");
    this.props.setHelperText({ helperText: text, open: true });
  }

  UpdateweekoffPlannerReducer() {
    const weekoffPlannerInfo = this.props.weekoffPlannerReducer;
    weekoffPlannerInfo.isaccumulation = this.state.isaccumulation;
    weekoffPlannerInfo.accumulationtypeid = this.state.accumulationtypeid;
    weekoffPlannerInfo.refreshtypeid = this.state.refreshtypeid;
    weekoffPlannerInfo.accumulationlimit = this.state.accumulationlimit;
    this.props.WeekoffPlanner({ ...weekoffPlannerInfo });
  }

  handleExpandClick01 = () => {
    this.HelperSliderFlag("HtAllowacc");
    this.setState({ isaccumulation: true }, () => {
      this.UpdateweekoffPlannerReducer();
    });
  };

  handleExpandClick02 = () => {
    this.HelperSliderFlag("HtAllowacc");
    this.setState(
      () => ({
        isaccumulation: false,
        expanded05: false,
        expanded06: false,
        expanded09: false,
        expanded10: false,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick03 = () => {
    this.setState(
      () => ({
        accumulationtypeid: 1,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick04 = () => {
    this.setState(
      () => ({
        accumulationtypeid: 2,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick05 = () => {
    this.setState(
      () => ({
        expanded05: true,
        expanded06: false,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick06 = () => {
    this.setState(
      () => ({
        expanded06: true,
        expanded05: false,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick07 = () => {
    this.setState(
      () => ({
        refreshtypeid: 1,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick08 = () => {
    this.setState(
      () => ({
        refreshtypeid: 2,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick09 = () => {
    this.setState(
      () => ({
        expanded09: true,
        expanded10: false,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick10 = () => {
    this.setState(
      () => ({
        expanded10: true,
        expanded09: false,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick11 = () => {
    this.setState(
      () => ({
        refreshtypeid: 1,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  handleExpandClick12 = () => {
    this.setState(
      () => ({
        refreshtypeid: 2,
      }),
      () => {
        this.UpdateweekoffPlannerReducer();
      },
    );
  };

  HandleKeyDown(e) {
    if ([69, 187, 188, 189, 190, 107, 109, 110].includes(e.keyCode)) {
      e.preventDefault();
    }
  }

  OnNumberChange(e) {
    let accumulationlimit;

    if (
      e.target.value < 0
      || Number.isNaN(e.target.value)
      || Number(e.target.value) > 365
      || Math.sign(e.target.value) == -1
    ) {
      accumulationlimit = "";
    } else {
      accumulationlimit = parseInt(e.target.value);
    }

    this.setState({ accumulationlimit }, () => {
      this.UpdateweekoffPlannerReducer();
    });
  }

  OnNext = () => {
    if (this.state.isaccumulation) {
      if (this.state.accumulationtypeid == 2) {
        if (this.state.accumulationlimit == null) {
          this.props.enqueueSnackbar("Please enter accumulation limit", {
            variant: "error",
          });
        } else if (this.state.expanded09 && !this.state.refreshtypeid) {
          this.props.enqueueSnackbar("Please select refresh weekly off", {
            variant: "error",
          });
        } else if (this.state.accumulationlimit == 0) {
          this.UpdateweekoffPlannerReducer();
          this.props.click();
        } else if (this.state.accumulationlimit != null) {
          this.UpdateweekoffPlannerReducer();
          this.props.click();
        } else if (this.state.expanded09 && this.state.refreshtypeid) {
          this.UpdateweekoffPlannerReducer();
          this.props.click();
        }
      } else if (this.state.accumulationtypeid == 1) {
        if (this.state.expanded05 && this.state.refreshtypeid) {
          this.UpdateweekoffPlannerReducer();
          this.props.click();
        } else if (this.state.expanded05 && !this.state.refreshtypeid) {
          this.props.enqueueSnackbar("Please select refresh weekly off", {
            variant: "error",
          });
        }
      } else {
        this.UpdateweekoffPlannerReducer();
        this.props.click();
      }
    } else {
      this.UpdateweekoffPlannerReducer();
      this.props.click();
    }
  };

  render() {
    return (
      <Grid container>
        <div className="stepper-scroller padding-top-0">
          <div className="stepper-scroller-content">
            <p className="add-label-active">
              <FormattedMessage
                id="HtAllowacc"
                defaultMessage="Allow accumulation of unused weekly offs?"
              />
            </p>
            <div
              className="depedent-select-list parent-selection"
              onClick={this.handleExpandClick01.bind(this)}
              aria-expanded={this.state.isaccumulation}
            >
              <span>
                <FormattedMessage id="Htyes" defaultMessage="Yes" />
              </span>
              {this.state.isaccumulation == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected"></span>
              )}
            </div>

            <div>
              <Collapse
                in={this.state.isaccumulation}
                timeout="auto"
                unmountOnExit
                className="first-level-collapse"
                style={{ margin: 0 }}
              >
                <div>
                  <div
                    className="depedent-select-list no-top-border"
                    onClick={this.handleExpandClick03}
                    aria-expanded={this.state.accumulationtypeid}
                  >
                    <span>
                      <FormattedMessage
                        id="HtUnlimitedacc"
                        defaultMessage="Unlimited Accumulation"
                      />
                    </span>
                    {this.state.accumulationtypeid == 1 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected"></span>
                    )}
                  </div>
                  {/*  Unlimited Accumulation   */}
                  <div>
                    <Collapse
                      in={this.state.accumulationtypeid == 1}
                      timeout="auto"
                      unmountOnExit
                      className="second-level-collapse"
                    >
                      <div>
                        <p className="add-label-active">
                          <FormattedMessage
                            id="HtRefresh"
                            defaultMessage="Reset accumulated weekly offs to zero, every month or year?"
                          />
                        </p>
                        <div
                          className="depedent-select-list no-top-border"
                          onClick={this.handleExpandClick05}
                          aria-expanded={this.state.expanded05}
                        >
                          <span>
                            <FormattedMessage id="Htyes" defaultMessage="Yes" />
                          </span>
                          {this.state.expanded05 == true ? (
                            <span className="floatright">
                              <img src={CheckImg} height="20" />
                            </span>
                          ) : (
                            <span className="not-selected"></span>
                          )}
                        </div>
                        <div>
                          <Collapse
                            in={this.state.expanded05}
                            timeout="auto"
                            unmountOnExit
                            className="third-level-collapse"
                          >
                            <div>
                              <div
                                className="depedent-select-list no-top-border"
                                onClick={this.handleExpandClick07}
                                aria-expanded={this.state.refreshtypeid}
                              >
                                <span>
                                  <FormattedMessage
                                    id="HtMonthly"
                                    defaultMessage="Monthly refresh of accumulated weekly off counts"
                                  />
                                </span>
                                {this.state.refreshtypeid == 1 ? (
                                  <span className="floatright">
                                    <img src={CheckImg} height="20" />
                                  </span>
                                ) : (
                                  <span className="not-selected"></span>
                                )}
                              </div>
                              <div
                                className="depedent-select-list "
                                onClick={this.handleExpandClick08}
                                aria-expanded={this.state.refreshtypeid}
                              >
                                <span>
                                  <FormattedMessage
                                    id="HtYearlyrefresh"
                                    defaultMessage="Yearly refresh of accumulated weekly off counts"
                                  />
                                </span>
                                {this.state.refreshtypeid == 2 ? (
                                  <span className="floatright">
                                    <img src={CheckImg} height="20" />
                                  </span>
                                ) : (
                                  <span className="not-selected"></span>
                                )}
                              </div>
                              {/* <div className="bottom-border"></div> */}
                            </div>
                          </Collapse>
                        </div>
                        <div
                          className="depedent-select-list "
                          onClick={this.handleExpandClick06}
                          aria-expanded={this.state.expanded06}
                        >
                          <span>
                            <FormattedMessage id="Htno" defaultMessage="No" />
                          </span>
                          {this.state.expanded06 == true ? (
                            <span className="floatright">
                              <img src={CheckImg} height="20" />
                            </span>
                          ) : (
                            <span className="not-selected"></span>
                          )}
                        </div>
                        {/* <div className="bottom-border"></div> */}
                      </div>
                    </Collapse>
                  </div>
                  <div
                    className="depedent-select-list "
                    onClick={this.handleExpandClick04}
                    aria-expanded={this.state.accumulationtypeid}
                  >
                    <span>
                      <FormattedMessage
                        id="HtLimitedacc"
                        defaultMessage="Limited Accumulation"
                      />
                    </span>
                    {this.state.accumulationtypeid == 2 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected"></span>
                    )}
                  </div>
                  {/*  Limited Accumulation   */}
                  <div>
                    <Collapse
                      in={this.state.accumulationtypeid == 2}
                      timeout="auto"
                      unmountOnExit
                      className="second-level-collapse"
                    >
                      <div>
                        <div>
                          <p className="add-label-active">
                            <FormattedMessage
                              id="HtLimitto"
                              defaultMessage="Limit to"
                            />
                          </p>

                          <span>
                            <input
                              type="number"
                              className="weekoff-number"
                              placeholder="00"
                              min="00"
                              max="365"
                              onChange={this.OnNumberChange.bind(this)}
                              onFocus={this.HelperSliderFlag.bind(
                                this,
                                "HtLimitto",
                              )}
                              value={this.state.accumulationlimit}
                              onKeyDown={this.HandleKeyDown.bind(this)}
                            />
                          </span>
                          <span className="number-of-weekly-off">
                            <FormattedMessage
                              id="HtNumberofwe"
                              defaultMessage="Number of weekly offs"
                            />
                          </span>
                        </div>
                        <p
                          style={{ marginTop: 5 }}
                          className="add-label-active"
                        >
                          <FormattedMessage
                            id="HtRefresh"
                            defaultMessage="Refresh accumulated weekly offs?"
                          />
                        </p>
                        <div
                          className="depedent-select-list no-top-border"
                          onClick={this.handleExpandClick09}
                          aria-expanded={this.state.expanded09}
                        >
                          <span>
                            <FormattedMessage id="Htyes" defaultMessage="Yes" />
                          </span>
                          {this.state.expanded09 == true ? (
                            <span className="floatright">
                              <img src={CheckImg} height="20" />
                            </span>
                          ) : (
                            <span className="not-selected"></span>
                          )}
                        </div>
                        <div>
                          <Collapse
                            in={this.state.expanded09}
                            timeout="auto"
                            unmountOnExit
                            className="third-level-collapse"
                          >
                            <div>
                              <div
                                className="depedent-select-list no-top-border"
                                onClick={this.handleExpandClick11}
                                aria-expanded={this.state.refreshtypeid}
                              >
                                <span>
                                  <FormattedMessage
                                    id="HtMonthly"
                                    defaultMessage="Monthly refresh of accumulated weekly off counts"
                                  />
                                </span>
                                {this.state.refreshtypeid == 1 ? (
                                  <span className="floatright">
                                    <img src={CheckImg} height="20" />
                                  </span>
                                ) : (
                                  <span className="not-selected"></span>
                                )}
                              </div>
                              <div
                                className="depedent-select-list "
                                onClick={this.handleExpandClick12}
                                aria-expanded={this.state.refreshtypeid}
                              >
                                <span>
                                  <FormattedMessage
                                    id="HtYearlyrefresh"
                                    defaultMessage="Yearly refresh of accumulated weekly off counts"
                                  />
                                </span>
                                {this.state.refreshtypeid == 2 ? (
                                  <span className="floatright">
                                    <img src={CheckImg} height="20" />
                                  </span>
                                ) : (
                                  <span className="not-selected"></span>
                                )}
                              </div>
                              {/* <div className="bottom-border"></div> */}
                            </div>
                          </Collapse>
                        </div>
                        <div
                          className="depedent-select-list "
                          onClick={this.handleExpandClick10}
                          aria-expanded={this.state.expanded10}
                        >
                          <span>
                            <FormattedMessage id="Htno" defaultMessage="No" />
                          </span>
                          {this.state.expanded10 == true ? (
                            <span className="floatright">
                              <img src={CheckImg} height="20" />
                            </span>
                          ) : (
                            <span className="not-selected"></span>
                          )}
                        </div>
                        {/* <div className="bottom-border"></div> */}
                      </div>
                    </Collapse>
                  </div>
                  {/* <div className="bottom-border"></div> */}
                </div>
              </Collapse>
            </div>

            <div
              className={
                this.state.isaccumulation == false
                  ? "depedent-select-list bg"
                  : "depedent-select-list no-bg"
              }
              onClick={this.handleExpandClick02.bind(this)}
              aria-expanded={this.state.isaccumulation}
            >
              <span>
                <FormattedMessage id="Htno" defaultMessage="No" />
              </span>
              {this.state.isaccumulation == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected"></span>
              )}
            </div>
            <div className="bottom-border"></div>
          </div>
        </div>
      </Grid>
    );
  }
}

Accumulation.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  weekoffPlannerReducer: state.weekoffPlannerReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      WeekoffPlanner: (data) => WeekoffPlanner(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(Accumulation)));
